import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
    root: {
        margin: "40px 0px",
    },
    title: {
        fontSize: "1.5rem !important",
        fontWeight: "500 !important",
        marginBottom: "20px !important",
        textAlign: "center",
    },
}));

const CCBillPayBangla = () => {
    const classes = useStyle();
    return (
        <div className={classes.root}>
            <Typography className={classes.title}>
                নিয়ম ও শর্তাবলী <br />
                “ক্রেডিট কার্ড বিল পরিশোধ”
            </Typography>

            <ol >
                <li>
                    এসটি পে গ্রাহকরা বাংলাদেশের যেকোনো তফসিলভুক্ত বাণিজ্যিক ব্যাংক কর্তৃক ইস্যুকৃত Visa এবং Mastercard ক্রেডিট কার্ডের বিল এসটি পে অ্যাকাউন্টের মাধ্যমে পরিশোধ করার যোগ্য।
                </li>
                <li>
                    প্রতিটি এসটি পে গ্রাহক বাংলাদেশ ব্যাংকের প্রযোজ্য বিধিমালা, এসটি পে অ্যাকাউন্ট লিমিট এবং সংশ্লিষ্ট কার্ড ইস্যুকারী ব্যাংকের নির্ধারিত সীমার মধ্যে থেকে এসটি পে অ্যাপের মাধ্যমে বাংলাদেশি টাকা (BDT) ব্যবহার করে একাধিকবার Visa/Mastercard ক্রেডিট কার্ড বিল পরিশোধ করতে পারবেন।
                </li>
                <li>
                    এসটি পে এই সেবার জন্য নির্দিষ্ট কোনো লেনদেন সংখ্যা সীমা আরোপ করে না; তবে গ্রাহকদের অবশ্যই সংশ্লিষ্ট কার্ড ইস্যুকারী ব্যাংকের পেমেন্ট নিয়ম, কাট-অফ সময়, বিলিং সাইকেল এবং ক্রেডিট লিমিট কঠোরভাবে অনুসরণ করতে হবে।
                </li>
                <li>
                    এই সেবার জন্য যোগ্য হতে গ্রাহকের একটি সক্রিয় এসটি পে অ্যাকাউন্ট থাকতে হবে যেখানে ব্যাংক অ্যাকাউন্ট ভেরিফিকেশন সম্পন্ন এবং পর্যাপ্ত ব্যালেন্স বিদ্যমান থাকবে।
                </li>
                <li>
                    এসটি পে এর মাধ্যমে জমাকৃত ক্রেডিট কার্ড বিল পরিশোধের অনুরোধ সংশ্লিষ্ট কার্ড ইস্যুকারী ব্যাংকে প্রসেসিংয়ের জন্য প্রেরণ করা হয়। ব্যাংকের অভ্যন্তরীণ প্রসেসিং সময় অনুযায়ী পেমেন্ট নিশ্চিতকরণ এবং স্ট্যাটাস আপডেট পেতে সর্বোচ্চ সাত (৭) কার্যদিবস পর্যন্ত সময় লাগতে পারে। এসটি পে ব্যাংকের প্রসেসিং সময় নিয়ন্ত্রণ বা নিশ্চিত করতে পারে না।
                </li>
                <li>
                    এই সেবার জন্য নির্ধারিত চার্জ প্রযোজ্য। ফি সম্পর্কে বিস্তারিত জানতে অনুগ্রহ করে
                    <a className="mx-2 text-blue-600 text-[18px]" style={{ fontWeight: "600", opacity: ".75", letterSpacing: "0.05px" }} href="https://stpay.net/terms-condition" target="_blank" rel="noreferrer">
                        https://stpay.net/terms-condition
                    </a>
                    ভিজিট করুন। এসটি পে প্রযোজ্য আইন ও বিধিমালা অনুযায়ী সময় সময়ে ফি ও চার্জ পরিবর্তনের অধিকার সংরক্ষণ করে।
                </li>
                <li>
                    এসটি পে শুধুমাত্র একটি <strong>পেমেন্ট সার্ভিস প্রোভাইডার (PSP)</strong> হিসেবে পেমেন্ট নির্দেশনা প্রেরণে সহায়তা করে। Visa, Mastercard এবং সংশ্লিষ্ট কার্ড ইস্যুকারী ব্যাংক ক্রেডিট কার্ড বিলিং, পোস্টিং, রিভার্সাল, সুদ, জরিমানা, লেট ফি বা বিরোধ নিষ্পত্তির জন্য সম্পূর্ণভাবে দায়ী। এসটি পে নিম্নলিখিত বিষয়ে দায়বদ্ধ থাকবে না:
                    <ul>
                        <li>কার্ড ইস্যুকারী ব্যাংকের আরোপিত লেট পেমেন্ট ফি বা জরিমানা</li>
                        <li>ব্যাংক প্রসেসিং, সিস্টেম ডাউনটাইম বা কাট-অফ টাইমের কারণে বিলম্ব</li>
                        <li>গ্রাহকের প্রদানকৃত ভুল ক্রেডিট কার্ড তথ্য</li>
                    </ul>
                    বিলিং সংক্রান্ত কোনো অসঙ্গতি বা জরিমানার ক্ষেত্রে গ্রাহককে সরাসরি সংশ্লিষ্ট কার্ড ইস্যুকারী ব্যাংকের সাথে যোগাযোগ করতে হবে।
                </li>
                <li>
                    এসটি পে কোনো পূর্বঘোষণা ছাড়াই এই সেবা বা এই শর্তাবলী আংশিক বা সম্পূর্ণভাবে পরিবর্তন, সংশোধন, স্থগিত বা বাতিল করার অধিকার সংরক্ষণ করে।
                </li>
                <li>
                    এই সেবার পরিচালনা, যোগ্যতা, স্থগিতকরণ বা অব্যাহত রাখার বিষয়ে এসটি পে-এর যেকোনো সিদ্ধান্ত চূড়ান্ত বলে গণ্য হবে এবং প্রযোজ্য আইন ও বিধিমালার অধীন থাকবে।
                </li>

                <br />
            </ol>

            <style>{`
                ol {
                    margin-left: -10px;
                    text-align: justify;
                }

                ol li::marker {
                    font-weight: 600;
                }

                ol li {
                    padding-left: 15px;
                    margin-bottom: 10px;
                }
            `}</style>

        </div>
    );
};

export default CCBillPayBangla;